import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_DELETE, llamadaAPI_GET, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { FormateoFechaPara_yyyyMMdd, TratamientoDeParametroParaURI } from '../../Varios';

export const function_ABM_ART_Articulos_Reservables_Excepciones_Listar = async (CodigoArticulo) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Reservables_Excepciones_Listar"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos_Reservables_Excepciones/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_Reservables_Excepciones_Leer = async (CodigoArticulo, Fecha) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Reservables_Excepciones_Leer"

    try {
        const resulData = await llamadaAPI_GET("ABM_ART_Articulos_Reservables_Excepciones/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo) + "/" +
            Fecha);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_Reservables_Excepciones_Generar_JSONBasico = async (fechaDesde, fechaHasta, codigoArticulo,
    disponible, cantidadMaxima, horaDesde, horaHasta) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Reservables_Excepciones_Generar_JSONBasico";

    try {
        const JSONList = [];
        const currentDate = new Date(fechaDesde);
        const endDate = new Date(fechaHasta);

        while (currentDate <= endDate) {
            const JSON = {
                CodigoCompania: localStorage.getItem("CodigoCompania"),
                CodigoArticulo: codigoArticulo,
                Fecha: await FormateoFechaPara_yyyyMMdd(currentDate),
                LunesDisponible: disponible,
                LunesCantidadMaxima: cantidadMaxima,
                LunesHoraDesde: horaDesde,
                LunesHoraHasta: horaHasta,
                MartesDisponible: disponible,
                MartesCantidadMaxima: cantidadMaxima,
                MartesHoraDesde: horaDesde,
                MartesHoraHasta: horaHasta,
                MiercolesDisponible: disponible,
                MiercolesCantidadMaxima: cantidadMaxima,
                MiercolesHoraDesde: horaDesde,
                MiercolesHoraHasta: horaHasta,
                JuevesDisponible: disponible,
                JuevesCantidadMaxima: cantidadMaxima,
                JuevesHoraDesde: horaDesde,
                JuevesHoraHasta: horaHasta,
                ViernesDisponible: disponible,
                ViernesCantidadMaxima: cantidadMaxima,
                ViernesHoraDesde: horaDesde,
                ViernesHoraHasta: horaHasta,
                SabadoDisponible: disponible,
                SabadoCantidadMaxima: cantidadMaxima,
                SabadoHoraDesde: horaDesde,
                SabadoHoraHasta: horaHasta,
                DomingoDisponible: disponible,
                DomingoCantidadMaxima: cantidadMaxima,
                DomingoHoraDesde: horaDesde,
                DomingoHoraHasta: horaHasta
            };

            JSONList.push(JSON);
            currentDate.setDate(currentDate.getDate() + 1);
        }

        const result = {
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            Registros: JSONList
        };

        return result;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_ABM_ART_Articulos_Reservables_Excepciones_Eliminar = async (CodigoArticulo, Fecha) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Reservables_Excepciones_Eliminar"

    try {
        const resulData = await llamadaAPI_DELETE("ABM_ART_Articulos_Reservables_Excepciones/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            await TratamientoDeParametroParaURI(CodigoArticulo) + "/" +
            Fecha);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_ABM_ART_Articulos_Reservables_Excepciones_Insertar = async (fechaDesde, fechaHasta, codigoArticulo,
    disponible, cantidadMaxima, horaDesde, horaHasta) => {
    const NombreFuncion = "function_ABM_ART_Articulos_Reservables_Excepciones_Insertar";

    try {
        const Articulo = await llamadaAPI_POST("ABM_ART_Articulos_Reservables_Excepciones/InsertarCompleto/",
            await function_ABM_ART_Articulos_Reservables_Excepciones_Generar_JSONBasico(fechaDesde, fechaHasta, codigoArticulo,
                disponible, cantidadMaxima, horaDesde, horaHasta));
        return Articulo;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};